import { useEffect, useState } from "react";

import { BsLinkedin } from "react-icons/bs";
import { toast } from "react-toastify";
import { images } from "../../constants";
import contact from "../../assets/contact.svg";
import website from "../../assets/website.png";
import { useSendEmailMutation } from "../../redux/api";
import { AppWrap, MotionWrap } from "../../wrapper";
import "./Footer.scss";
import { links } from "../../constants/links";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    text: "",
  });

  const [sendEmail, { isLoading, data, isSuccess }] = useSendEmailMutation();

  const { name, email, text } = formData;

  useEffect(() => {
    if (isSuccess) toast.success("Successfully submitted");
  }, [data, isSuccess]);

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const data = {
      name,
      email,
      text,
    };
    console.log(data);
    sendEmail(data)
      .unwrap()
      .then((res) => {
        console.log("res", res);
      })
      .catch((err) => console.log("err", err));
  };
  // const github = 'https://github.com/PeterKampete';
  return (
    <>
      {/* <ToastContainer /> */}

      <h2 className="head-text">Let's get me Hired!</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="Email" />
          <a
            href="mailto:obentabiayuk1@gmail.com"
            className="p-text"
            style={{ marginLeft: "10px" }}
          >
            obentabiayuk1@gmail.com
          </a>
        </div>
        <div
          className="app__footer-card"
          style={{
            backgroundColor: "#f3f5ff",
          }}
        >
          <img src={contact} alt="Mobile" style={{ marginRight: "10px" }} />
          <a href="tel: (+1) 704-363-5908" className="p-text">
            (+237) 676-49-2408
          </a>
        </div>
        <div className="app__footer-card">
          <img src={website} alt="email" style={{ marginRight: "10px" }} />
          <a
            href={links.PORTFOLIO}
            target="_blank"
            className="p-text"
            rel="noreferrer"
          >
            https://obentabiayuk.dev
          </a>
        </div>
      </div>
      {/* {isSuccess ? (
        <div>
          <h3 className='head-text'>Thank you for getting in touch!</h3>
        </div>
      ) : (
        <div className='app__footer-form app__flex'>
          <div className='app__flex'>
            <input
              className='p-text'
              type='text'
              placeholder='Your Name'
              name='name'
              value={name}
              onChange={handleChangeInput}
            />
          </div>
          <div className='app__flex'>
            <input
              className='p-text'
              type='email'
              placeholder='Your Email'
              name='email'
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className='p-text'
              placeholder='Your Message'
              value={text}
              name='text'
              onChange={handleChangeInput}
            />
          </div>
          <button
            type='button'
            className='p-text'
            disabled={!text || !email || !name || isLoading}
            onClick={handleSubmit}
            style={{
              width: '100%',
              textAlign: 'center',
              background: (!text || !email || !name || isLoading) && 'grey',
            }}
          >
            {isLoading ? 'Sending' : 'Send Message'}
          </button>
        </div>
      )} */}
      <div className="footer__links">
        <a href={links.LINKEDIN} rel="noreferrer" target="_blank">
          <div>
            <BsLinkedin />
          </div>
        </a>
        {/* <a href={github} rel='noreferrer' target='_blank'>
          <div>
            <BsGithub />
          </div>
        </a> */}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
